import { Component } from '@verndale/core';

class TagsRow extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      printDropdown: this.el.querySelector<HTMLElement>('.boat-header__print-dropdown'),
      shareBtn: this.el.querySelector<HTMLElement>('.boat-header__share'),
      printBtn: this.el.querySelector<HTMLElement>('.boat-header__print'),
      boatHeaderTitle: document.querySelector<HTMLElement>('.boat-header__title'),
      toastElement: document.querySelector<HTMLElement>('#toast')
    };
  }

  addListeners() {
    (this.dom.shareBtn as HTMLElement).addEventListener('click', this.handleShareClick.bind(this));
    (this.dom.printBtn as HTMLElement).addEventListener('click', this.handlePrintClick.bind(this));
    (this.dom.printDropdown as HTMLElement).addEventListener(
      'mouseleave',
      this.handleCloseDropdown.bind(this)
    );
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  handleShareClick() {
    const urlToShare = window.location.href.split('?')[0];

    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: (this.dom.boatHeaderTitle as HTMLElement).textContent || '',
          url: urlToShare
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(urlToShare);
      (this.dom.toastElement as HTMLElement)?.classList.add('show');
      setTimeout(() => {
        (this.dom.toastElement as HTMLElement)?.classList.remove('show');
      }, 3000);
    }
  }

  handleClickOutside(e: Event) {
    const target = e.target as HTMLElement;
    if (target !== this.dom.printBtn) {
      (this.dom.printDropdown as HTMLElement).classList.remove('show');
    }
  }

  handleCloseDropdown(e: Event) {
    const target = e.target as HTMLElement;
    target.classList.remove('show');
  }

  handlePrintClick() {
    (this.dom.printDropdown as HTMLElement).classList.toggle('show');
  }
}

export default TagsRow;
